import React, { useState } from 'react';
import Navbar from './components/Navbar.js';
import Footer from './components/Footer.js';
import AIChatBox from './components/AIChatBox.js';
import HomePage from './pages/HomePage.js';
import ProgramPage from './pages/ProgramPage.js';
import EventsPage from './pages/EventsPage.js';
import PartnersPage from './pages/PartnersPage.js';
import CommunityPage from './pages/CommunityPage.js';
import DashboardPage from './pages/DashboardPage.js';
import LoginPage from './pages/LoginPage.js';
import ContactPage from './pages/ContactPage.js';
import AssessmentPage from './pages/assessmentpage.js';

// Main App Component
export default function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [showAIChat, setShowAIChat] = useState(false);

  const pages = {
    home: <HomePage setCurrentPage={setCurrentPage} />,
    program: <ProgramPage setCurrentPage={setCurrentPage} />,
    partners: <PartnersPage setCurrentPage={setCurrentPage} />,
    events: <EventsPage setCurrentPage={setCurrentPage} />,
    community: <CommunityPage setCurrentPage={setCurrentPage} />,
    dashboard: <DashboardPage setShowAIChat={setShowAIChat} setCurrentPage={setCurrentPage} />,
    login: <LoginPage setUser={setUser} setCurrentPage={setCurrentPage} />,
    contact: <ContactPage />,
    assessment: <AssessmentPage setCurrentPage={setCurrentPage} />
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #c7d2fe 100%)'
    }}>
      <Navbar 
        currentPage={currentPage} 
        setCurrentPage={setCurrentPage}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        user={user}
      />
      
      <main style={{ paddingTop: '64px' }}>
        {pages[currentPage]}
      </main>

      {showAIChat && <AIChatBox setShowAIChat={setShowAIChat} />}
      
      <Footer setCurrentPage={setCurrentPage} />
    </div>
  );
}